var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-pascal-case */
import { Control, Field, actions as formActions } from 'react-redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import PropertyConfigOptions from "./PropertyConfigOptions";
import { RelationshipsQueryBuilder } from "./RelationshipsQueryBuilder/RelationshipsQueryBuilder";

class FormConfigNewRelationshipComponent extends Component {
  static contentValidation() {
    return { required: (val) => val && val.trim() !== '' };
  }

  constructor(props) {
    super(props);
    this.state = { inherit: props.showInheritSelect };
    this.onInheritTypeChange = this.onInheritTypeChange.bind(this);
  }

  onInheritTypeChange() {
    const { index } = this.props;
    this.props.resetFormValue(`template.data.properties[${index}].filter`);
  }

  render() {
    const { index, type, labelError, inheritSelectPropertyType } = this.props;

    const labelClass = labelError ? 'form-group has-error' : 'form-group';
    const canBeFilter =
    !this.state.inherit ||
    this.state.inherit &&
    !['image', 'geolocation', 'preview', 'media', 'link'].includes(inheritSelectPropertyType);
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: labelClass }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Label")
      ), /*#__PURE__*/
      _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { id: "label", className: "form-control" })
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Query")
      ), /*#__PURE__*/
      _jsx(Control, {
        component: RelationshipsQueryBuilder,
        model: `template.data.properties[${index}].query` }
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("label", { "no-translate": true }, void 0, "Denormalized property"), /*#__PURE__*/
      _jsx(Field, { model: `template.data.properties[${index}].denormalizedProperty` }, void 0, /*#__PURE__*/
      _jsx("input", { id: "denormalizedProperty", className: "form-control" })
      )
      ), /*#__PURE__*/
      _jsx(PropertyConfigOptions, { canBeFilter: canBeFilter, index: index, type: type })
      ));

  }
}

FormConfigNewRelationshipComponent.defaultProps = {
  labelError: false,
  showInheritSelect: false,
  inheritSelectPropertyType: null
};










function mapStateToProps(state, props) {
  const { template, templates, relationTypes } = state;

  return {
    labelError:
    template.formState.$form.errors[`properties.${props.index}.label.required`] ||
    template.formState.$form.errors[`properties.${props.index}.label.duplicated`],

    relationTypeError:
    template.formState.$form.errors[`properties.${props.index}.relationType.required`] &&
    template.formState.$form.submitFailed,
    templateId: template.data._id,
    templates,
    relationTypes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      resetFormValue: (model) => formActions.reset(model)
    },
    dispatch
  );
}

export const FormConfigNewRelationship = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormConfigNewRelationshipComponent);